import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { ISubscriptionState, mapSubscriptionStateToProps } from "../../redux/reducers/subscription";
import { ISubscriptionActionDispatches, mapSubscriptionDispatchToProps } from "../../redux/actions/subscription";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import { BWMembershipStatus } from "../../models/bwMembership";
import { getDateDisplay } from "../../utils/date-utils";

class MembershipDetails extends Component<
	ISubscriptionActionDispatches & ISubscriptionState & RouteComponentProps & IAuthProps
> {
	componentDidMount() {
		this.props.loadSubscription(this.props.authContext);
	}

	render() {
		return (
			<>
				<h4 className="mt-4 mb-1">{process.env.REACT_APP_CLIENT_NAME} Membership</h4>
				{this.props.membershipDetails.status === BWMembershipStatus.ACTIVE && (
					<div className="mt-1 text-sm d-inline-flex align-items-center">
						<i className="im im-check-mark text-xxs" style={{ marginTop: "1px", marginRight: "5px" }}></i>
						Benefit and Welfare Member
						{!!this.props.membershipDetails.validThrough && (
							<span className="text-gray text-xxs pl-1">
								(Valid until {getDateDisplay(this.props.membershipDetails.validThrough, null)})
							</span>
						)}
					</div>
				)}
				{this.props.membershipDetails.status !== BWMembershipStatus.ACTIVE && (
					<div className="mt-1 text-sm">
						{!this.props.membershipDetails.isSubscriber && (
							<NavLink to="/bw-membership-request">
								{this.props.membershipDetails.status === BWMembershipStatus.INACTIVE &&
									"Request membership"}
								{this.props.membershipDetails.status === BWMembershipStatus.EXPIRED &&
									"Request renewal"}
							</NavLink>
						)}
						{!!this.props.membershipDetails.isSubscriber && (
							<NavLink to="/checkout#!/~/cart">
								{this.props.membershipDetails.status === BWMembershipStatus.INACTIVE &&
									"Add membership"}
								{this.props.membershipDetails.status === BWMembershipStatus.EXPIRED &&
									"Renew membership"}
							</NavLink>
						)}
						{this.props.membershipDetails.status === BWMembershipStatus.EXPIRED && (
							<span className="text-gray text-xxs pl-1">
								(Expired {getDateDisplay(this.props.membershipDetails.validThrough, null)})
							</span>
						)}
					</div>
				)}
			</>
		);
	}
}

export default connect<ISubscriptionState, ISubscriptionActionDispatches>(
	mapSubscriptionStateToProps,
	mapSubscriptionDispatchToProps
)(withAuth(MembershipDetails));
